import type { CSSProperties, ReactNode } from "react";

export interface DecorativePlacementProps {
  readonly id: string;
  readonly style: CSSProperties;
  readonly children: ReactNode;
}

export function DecorativePlacement({ id, style, children }: DecorativePlacementProps) {
  return (
    <div
      aria-hidden="true"
      data-testid={`register-success-decoration-${id}`}
      className="absolute"
      style={{ opacity: 0.5, ...style }}
    >
      {children}
    </div>
  );
}
